/* eslint-disable @typescript-eslint/no-unsafe-return */
import { VacancyRecruiterCardProps } from "storyblok/components";
import Image from "next/legacy/image";

import { CONVERSATION, Icon } from "components/ui";

import {
    Container,
    LinkText,
    Picture,
    Wrapper
} from "./VacancyRecruiterCard.styled";

export function VacancyRecruiterCard({
    picture,
    showContactForm
}: VacancyRecruiterCardProps): JSX.Element {
    return (
        <Container>
            <Wrapper>
                <Picture onClick={() => showContactForm(true)}>
                    {picture ? (
                        <Image
                            src={picture?.filename || ""}
                            width={52}
                            height={52}
                            objectFit="cover"
                            draggable={false}
                        />
                    ) : (
                        <Icon icon={CONVERSATION} size={24} />
                    )}
                </Picture>

                <div>
                    <p>Vrijblijvend kennismaken?</p>
                    <LinkText onClick={() => showContactForm(true)}>
                        Neem contact op met onze recruiter
                    </LinkText>
                </div>
            </Wrapper>
        </Container>
    );
}
